import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getLeaderKeys} from '../../../apis/leader/getLeaderKeysAll'

const useQueryLeaderKeysAll = (userId: string) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.copyTrading.getLeadersKeyAll(userId),
        queryFn: async () => {
            const {data} = await getLeaderKeys(userId)
            return {data}
        },
        refetchOnWindowFocus: false,
        refetchOnMount: false,
    })

    return {data, refetch}
}

export default useQueryLeaderKeysAll
